import React, { useState, useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import SelectTab from '../share/SelectTab';
import Total from './total/total';
import Items from './items/items';

const AgodaHotelTab = {
  TOTAL: '総数',
  ITEMS: '全件'
} as const;
export type AgodaHotelTabType = keyof typeof AgodaHotelTab;

const AgodaHotel = observer(() => {
  const history = useHistory();
  const [agodaHotelTab, setAgodaHotelTab] = useState<AgodaHotelTabType>(
    (utils.getParam('agoda_hotel_type') as AgodaHotelTabType) || 'TOTAL'
  );

  useEffect(() => {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
    currentParams.set('sub_tab', 'AGODA_HOTEL');
    if (!currentParams.has('agoda_hotel_type')) {
      currentParams.set('agoda_hotel_type', agodaHotelTab);
    }
    history.replace(`/arrangement/todo_list?${currentParams.toString()}`);
  }, [history, agodaHotelTab]);

  const handleTabChange = useCallback(
    (tab: AgodaHotelTabType) => {
      setAgodaHotelTab(tab);
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
      currentParams.set('sub_tab', 'AGODA_HOTEL');
      currentParams.set('agoda_hotel_type', tab);
      history.push(`/arrangement/todo_list?${currentParams.toString()}`);
    },
    [history]
  );

  return (
    <>
      <SelectTab tabs={AgodaHotelTab} currentTab={agodaHotelTab} onChange={handleTabChange} />
      {agodaHotelTab === 'ITEMS' ? <Items /> : <Total />}
    </>
  );
});

export default AgodaHotel;
